
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignGetStartedIntroduction',
  components: { DesignContentLayout }
};
